import { defineStore } from 'pinia'
import type { AppState, Language, Theme } from './helper'
import { getLocalSetting, setLocalSetting } from './helper'

import { store } from '@/store'
import { useQuickEntry } from '@/hooks/useQuickEntry'

export const useAppStore = defineStore('app-store', {
  state: (): AppState => getLocalSetting(),
  actions: {
    setSiderCollapsed(collapsed: boolean) {
      this.siderCollapsed = collapsed
      this.recordState()
    },

    setRedirectSystemCode(redirectSystemCode: string) {
      this.redirectSystemCode = redirectSystemCode
      localStorage.setItem('redirectSystemCode', redirectSystemCode)
    },

    setRedirectSystem(redirectSystem: string) {
      // 记录需要回调的系统，目前主要用在报告系统
      this.redirectSystem = redirectSystem
      localStorage.setItem('redirectSystem', redirectSystem)
    },

    redirectToSystem() {
      if (localStorage.getItem('redirectSystemCode') && localStorage.getItem('redirectSystem')) {
        const { handleClick } = useQuickEntry()

        handleClick({ code: localStorage.getItem('redirectSystemCode'), url: '', redirectUrl: localStorage.getItem('redirectSystem') || '' })

        this.clearRedirectSystem()
      }
    },
    clearRedirectSystem() {
      this.redirectSystem = ''
      this.redirectSystemCode = ''
      localStorage.setItem('redirectSystem', '')
      localStorage.setItem('redirectSystemCode', '')
    },

    removeRedirectSystem() {
      this.redirectSystem = ''
    },

    setTheme(theme: Theme) {
      this.theme = theme
      this.recordState()
    },

    setLanguage(language: Language) {
      if (this.language !== language) {
        this.language = language
        this.recordState()
      }
    },

    toggleSidebarCollapsed() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
    },

    recordState() {
      setLocalSetting(this.$state)
    },
  },
})

export function useAppStoreWithOut() {
  return useAppStore(store)
}
